<template>
  <div class="st-ives-questionnaire">
   
      <TitleText :smallTitle="true" title="St Ives engagement has been closed." />
    <!-- <div id="element" ref="messages">&nbsp;</div>
    <SectionMap
      
      :currentSection="currentSection"
      @event="setCurrentSection"
      ref="sectionMap"
    />
    
    <section :class="currentSection == 0 ? '' : 'hidden'">
      <div>
        <TitleText :smallTitle="true" :title="section1Content.title" />
        <p>
          Please share your views with us by completing this response form. The
          engagement starts 14th June and ends 5th July 5:00pm
        </p>
        <p>
          Contact us at:
          <a href="mailto:yourstives@cambridgeshirepeterborough-ca.gov.uk"
            >yourstives@cambridgeshirepeterborough-ca.gov.uk</a
          >
        </p>
        <p>
          If you would like to request a brochure please
          <a href="mailto:yourstives@cambridgeshirepeterborough-ca.gov.uk"
            >email</a
          >
          or call freephone 0800 054 1163
        </p>

        <p>
          <a
            target="_blanck"
            href="https://cambridgeshirepeterborough-ca.gov.uk/about-us/transparency/data-protection-policy/"
            >Please click for out GDPR statement</a
          >
        </p>
      </div>
    </section>
    <section :class="currentSection == 1 ? '' : 'hidden'">
      <div>
        <TitleText
          :smallTitle="true"
          :title="section2Content.title"
          :text="section2Content.text"
        />
      </div>

      <div class="survey-input">
        <NameAddress ref="addressInput" />
      </div>
    </section>
    <section :class="currentSection == 2 ? '' : 'hidden'">
      <div>
        <TitleText :smallTitle="true" :title="section3Content.title" />
      </div>
      <div class="survey-input">
        <RadioButtonTable
          ref="issues_concern"
          :id="'question3'"
          :commentBox="false"
          :questions="section3Content.question1.questions"
          :answers="section3Content.question1.answers"
          :listOn="false"
          :titleText="section3Content.question1.title"
        />
      </div>
      <div class="survey-input">
        <RadioButtonTable
          ref="residential_street_vil"
          :id="'question4'"
          :commentBox="false"
          :questions="section3Content.question2.questions"
          :answers="section3Content.question2.answers"
          :listOn="false"
          :titleText="section3Content.question2.title"
        />
      </div>
      <div class="survey-input">
        <RadioColumn
          ref="travel_method"
          :id="'question5'"
          :questions="section3Content.question3.questions"
          :titleText="section3Content.question3.title"
        />
      </div>
      <div class="survey-input">
        <RadioColumn
          ref="special_interest"
          :id="'question6'"
          :questions="section3Content.question4.questions"
          :titleText="section3Content.question4.title"
          :multipleValues="true"
        />
      </div>
    </section>
    <section :class="currentSection == 3 ? '' : 'hidden'">
      <div>
        <TitleText :smallTitle="true" :title="section4Content.title" />
      </div>
      <div class="survey-input">
        <RadioColumn
          ref="reduce_road_traffic"
          :id="'question7'"
          :questions="section4Content.question1.questions"
          :titleText="section4Content.question1.title"
        />
      </div>
      <div class="survey-input">
        <RadioButtonTable
          ref="public_transport_ease"
          :id="'question8'"
          :commentBox="false"
          :questions="section4Content.question2.questions"
          :answers="section4Content.question2.answers"
          :listOn="false"
          :titleText="section4Content.question2.title"
        />
      </div>
      <div class="survey-input">
        <RadioButtonTable
          ref="non_motorised_users"
          :id="'question9'"
          :commentBox="false"
          :questions="section4Content.question3.question"
          :answers="section4Content.question3.answers"
          :listOn="false"
          :titleText="section4Content.question3.title"
        />
      </div>
      <div class="survey-input">
        <RadioButtonTable
          ref="local_transport_network"
          :id="'question10'"
          :commentBox="false"
          :questions="section4Content.question4.question"
          :answers="section4Content.question4.answers"
          :listOn="false"
          :titleText="section4Content.question4.title"
        />
      </div>
      <div class="survey-input">
        <div class="pins-input">
          <div class="pi-text">
            <p>{{ section4Content.question5.title }}</p>
            <p>{{ section4Content.question5.text }}</p>
          </div>
          <div class="pi-inputs">
            <button class="previous-btn" v-if="!pinsActive" @click="addPins">
              Edit pinpoints
            </button>
            <button class="previous-btn" v-else @click="finishPins">
              Finish
            </button>
          </div>
          <div
            class="pi-inputs"
            v-for="(input, index) in pinComments"
            :key="`pincommentbox_${index}`"
          >
            <div>
              <p>Comment for Pin {{ input }}:</p>
              <textarea
                placeholder="Enter your comment here..."
                v-model="pinCommentsInputs[index]"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section :class="currentSection == 4 ? '' : 'hidden'">
      <div v-if="optionModal">
        <TabsModal />
      </div>

      <div>
        <TitleText :smallTitle="true" :title="section5Content.title" />
      </div>
      <div>
        <button class="text-btn" @click="openOptionModal">
          Please click here to view the Options
        </button>
      </div>
      <div class="survey-input">
        <SelectionDropdowns
          ref="choice1"
          :title="section5Content.question1.title"
          :options="section5Content.question1.options"
        />
      </div>
      <div class="survey-input">
        <SelectionDropdowns
          ref="choice2"
          :title="section5Content.question2.title"
          :options="section5Content.question2.options"
        />
      </div>
      <div class="survey-input">
        <SelectionDropdowns
          ref="choice3"
          :title="section5Content.question3.title"
          :options="section5Content.question3.options"
        />
      </div>
      <div>
        <p>{{ section5Content.question4.title }}</p>
      </div>
      <div class="survey-input">
        <SelectionDropdowns
          :options="section5Content.question4.questions"
          ref="combination1"
        />
      </div>
      <div class="survey-input">
        <SelectionDropdowns
          :options="section5Content.question4.questions"
          ref="combination2"
        />
      </div>
      <div class="survey-input">
        <SelectionDropdowns
          :options="section5Content.question4.questions"
          ref="combination3"
        />
      </div>
      <div class="survey-input">
        <SelectionDropdowns
          :options="section5Content.question4.questions"
          ref="combination4"
        />
      </div>
      <div class="survey-input">
        <SelectionDropdowns
          :options="section5Content.question4.questions"
          ref="combination5"
        />
      </div>
    </section>
    <section :class="currentSection == 5 ? '' : 'hidden'">
      <div class="survey-input">
        <OptionComments
          ref="other_comments"
          :id="'other_comments'"
          :textTitle="section5Content.question5.title"
          :options="[
            {
              optionDetail:
                'If you wish to submit additional comments please use the comment box below',
            },
          ]"
        />
      </div>
    </section>
    <section :class="currentSection == 6 ? '' : 'hidden'">
      <TitleText :title="section6Content.title" :text="section6Content.text" />
    </section>
    <section class="section-stage-btns">
      <button
        v-scroll-to="'#element'"
        class="continue-btn"
        v-if="currentSection < totalSections && currentSection != 5"
        @click="nextSection"
      >
        Continue
      </button>
      <button
        class="continue-btn"
        v-if="currentSection == 5"
        @click="submitFeedbackLocal"
      >
        Submit Feedback
      </button>
      <button
        class="previous-btn"
        v-if="currentSection > 0 && currentSection < 6"
        @click="prevSection"
      >
        Go back
      </button>
 
    </section> -->
  </div>
</template>

<script>
import TitleText from "../comps/TitleText";
import NameAddress from "../FormComps/NameAddress";
import RadioButtonTable from "../FormComps/RadioButtonTable";
import RadioColumn from "../FormComps/RadioColumn";
import SelectionDropdowns from "../FormComps/SelectionDropdowns";
import OptionComments from "../FormComps/OptionComments.vue";
import Stepper from "@/components/FormStepper";
import TabsModal from "@/components/customPages/components/TabsModal";
import SectionMap from "@/components/stIves/SectionMap";
import FeedbackFormatter from "@/services";
import LimitedRadioColumn from "../FormComps/LimitedRadioColumn.vue";
import { mapActions } from "vuex";

import content from "../../questionnaireContent/index";

export default {
  name: "Questionnaire",
  props: {
    pinsActive: {
      type: Boolean,
    },
    pinCoords: {
      type: Array,
    },
  },
  data() {
    return {
      currentSection: 0,
      totalSections: 5,
      optionModal: false,
      pinpointEventSource: {},
      pinComments: [1, 2, 3, 4, 5],
      pinCommentsInputs: [],
    };
  },
  components: {
    TitleText,
    NameAddress,
    RadioButtonTable,
    RadioColumn,
    SelectionDropdowns,
    Stepper,
    TabsModal,
    SectionMap,
    OptionComments,
    LimitedRadioColumn,
  },

  mounted(){
    
  },
  computed: {
    questionnaireContent() {
      return content;
    },
    section1Content() {
      return this.questionnaireContent.section1;
    },
    section2Content() {
      return this.questionnaireContent.section2;
    },
    section3Content() {
      return this.questionnaireContent.section3;
    },
    section4Content() {
      return this.questionnaireContent.section4;
    },
    section5Content() {
      return this.questionnaireContent.section5;
    },
    section6Content() {
      return this.questionnaireContent.section6;
    },
  },
  methods: {
    ...mapActions(["submitFeedback"]),
    nextSection() {
      this.currentSection++;
      if (this.currentSection < 6) {
        this.$refs.sectionMap.progressUpdate(this.currentSection);
      }
      document.getElementById('element').scrollIntoView()
      this.collectFeedbackData();
    },
    prevSection() {
      this.currentSection--;
       document.getElementById('element').scrollIntoView()
      this.$refs.sectionMap.progressUpdate(this.currentSection);
    },
    getCoordData() {
      let data1 = this.pinCoords[0]
        ? this.pinCoords[0].geometry.coordinates
        : ["not given", "not given"];
      let data2 = this.pinCoords[1]
        ? this.pinCoords[1].geometry.coordinates
        : ["not given", "not given"];
      let data3 = this.pinCoords[2]
        ? this.pinCoords[2].geometry.coordinates
        : ["not given", "not given"];
      let data4 = this.pinCoords[3]
        ? this.pinCoords[3].geometry.coordinates
        : ["not given", "not given"];
      let data5 = this.pinCoords[4]
        ? this.pinCoords[4].geometry.coordinates
        : ["not given", "not given"];

      return [
        { coords: data1, comment: this.pinCommentsInputs[0] },
        { coords: data2, comment: this.pinCommentsInputs[1] },
        { coords: data3, comment: this.pinCommentsInputs[2] },
        { coords: data4, comment: this.pinCommentsInputs[3] },
        { coords: data5, comment: this.pinCommentsInputs[4] },
      ];
    },
    collectFeedbackData() {
      //console.log(this.$refs.local_transport_network);
      let collected = {
        address: this.$refs.addressInput.nameAddressData,
        question1: this.$refs.issues_concern.tableAnswers,
        question2: this.$refs.residential_street_vil.tableAnswers,
        question3: this.$refs.travel_method.radioFeedback,
        question4: this.$refs.special_interest.radioFeedback,
        question5: this.$refs.reduce_road_traffic.radioFeedback,
        question6: this.$refs.public_transport_ease.tableAnswers,
        question7: this.$refs.non_motorised_users.tableAnswers,
        question8: this.$refs.local_transport_network.tableAnswers,
        question9: this.getCoordData(),
        choice1: this.$refs.choice1.optionSelect,
        choice2: this.$refs.choice2.optionSelect,
        choice3: this.$refs.choice3.optionSelect,
        question11: [
          this.$refs.combination1.optionSelect,
          this.$refs.combination2.optionSelect,
          this.$refs.combination3.optionSelect,
          this.$refs.combination4.optionSelect,
          this.$refs.combination5.optionSelect,
        ],
        comments: this.$refs.other_comments.feedBackData[0],
      };
      return collected;
    },
    submitFeedbackLocal() {
      let feedback = this.collectFeedbackData();
      let formated = new FeedbackFormatter(feedback).format();
      let response = this.submitFeedback(formated);
      this.nextSection();
    },
    openOptionModal() {
      this.optionModal = true;
    },
    closeOptionModal() {
      this.optionModal = false;
    },
    setCurrentSection(index) {
      this.currentSection = index;
    },
    addPins() {
      this.$emit("registerPin");
      this.$emit("setPinsActive");
    },
    finishPins() {
      this.$emit("deRegisterPin");
      this.$emit("setPinsActive");
    },
  },
};
</script>

<style lang="scss" scoped>
.st-ives-questionnaire {
  section {
    &.hidden {
      display: none;
    }

    a {
      color: #037dba !important;
    }

    &.section-stage-btns {
      .continue-btn {
        padding: 10px 35px;
        border-radius: 4px;
        background-color: #15243c;
        color: white;
        border: none;

        &:hover {
          background-color: #234273;
        }
      }
      .previous-btn {
        padding: 10px 35px;
        background: transparent;
        color: #15243c;
        text-decoration: underline;
        border: none;
      }
    }

    .text-btn {
      background: transparent;
      color: #15243c;
      text-decoration: underline;
      border: none;
    }

    .survey-input {
      margin: 30px 0;
    }

    .pins-input {
      .pi-text {
        p {
          color: #15243c;
          font-weight: bold;
        }
      }

      .pi-inputs {
        button {
          padding: 10px 35px;
          border-radius: 4px;
          background-color: #15243c;
          color: white;
          border: none;
        }

        p {
          padding-bottom: none;
        }

        textarea {
          height: 260px;
          border-color: rgba(#15243c, 0.3);
          padding: 10px;
        }
      }
    }
  }
}
</style>